<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { Snippet } from 'svelte';

  type Variant = 'mute' | 'unmute' | 'leave';

  interface Props {
    variant: Variant;
    disabled?: boolean;
    ariaLabel: string;
    onclick?: (event: MouseEvent) => void;
    children?: Snippet;
  }

  let { variant, disabled = false, ariaLabel, onclick, children }: Props = $props();

  const cls: Record<Variant, string> = {
    mute: 'bg-white/10 hover:bg-white/20',
    unmute: 'bg-red-500/90 hover:bg-red-500',
    leave: 'bg-red-500 hover:bg-red-400 shadow-lg shadow-red-500/30',
  };
</script>

<button
  type="button"
  aria-label={ariaLabel}
  {disabled}
  onclick={(e) => onclick?.(e)}
  class="w-14 h-14 rounded-full flex items-center justify-center transition active:scale-95 disabled:opacity-50 {cls[
    variant
  ]}"
>
  {@render children?.()}
</button>
